import { HamburgerCloseIcon } from "@shapr3d/frontend-lib";
import classNames from "classnames";

import { useBoundingElement } from "../../hooks/useBoundingElement";

import style from "./Sidebar.module.css";

interface SidebarProps {
  children?: React.ReactNode;
  controlButtons?: React.ReactNode;
  title?: string;
  position: "left" | "right";
  isOpen: boolean;
  isDisabled?: boolean;
  onClose: () => void;
}

export const Sidebar = ({
  children,
  title,
  position,
  isOpen,
  controlButtons,
  isDisabled,
  onClose,
}: SidebarProps) => {
  const elementRef = useBoundingElement();
  return (
    <div
      ref={elementRef}
      className={classNames(
        style.sidebar,
        !isOpen && style.closed,
        position === "left" && style.left,
        position === "right" && style.right,
        isDisabled && style.disabled
      )}
    >
      <div className={style.title}>
        {title}
        <div className={style.closeButton} onClick={onClose}>
          <HamburgerCloseIcon open={true} />
        </div>
      </div>
      <div className={classNames(style.content)}>{children}</div>
      <div
        className={classNames(
          style.controlButtons,
          position === "left" && style.left,
          position === "right" && style.right
        )}
      >
        {controlButtons}
      </div>
    </div>
  );
};
